module.exports = __webpack_public_path__ + "static/media/banner2.3d677f32.jpg";